import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  initialize() {}

  connect() {
    this.initialized = true;
    useMatchMedia(this, {
      mediaQueries: {
        md: '(min-width: 992px)',
      },
    });
    this.isDesktopLayout = window.matchMedia(
      '(min-width: 992px)'
    ).matches;
  }

  static targets = ['item', 'content', 'trigger', 'icon', 'bg'];

  mdChanged({ name, media, matches, event }) {
    this.isDesktopLayout = matches;
    this.closeAll();
  }

  toggle(e) {
    const target = e.target.closest(
      '[data-nav-dropdown-target=item]'
    );

    if (this.isDesktopLayout) {
      this.closeAll(target);
    }

    this.toggleDropdown(target);

    const trigger = target.querySelector(
      '[data-nav-dropdown-target=trigger]'
    );
    const isExpanded =
      trigger.getAttribute('aria-expanded') === 'true';
    this.toggleOverlayBg(isExpanded);
  }

  toggleDropdown(target) {
    const trigger = target.querySelector(
      '[data-nav-dropdown-target=trigger]'
    );

    let isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    isExpanded = !isExpanded;

    trigger.setAttribute('aria-expanded', isExpanded);

    trigger.classList.toggle('md:underline', isExpanded);
    trigger.classList.toggle('md:!text-darkgreen', isExpanded);

    const icon = target.querySelector(
      '[data-nav-dropdown-target=icon]'
    );
    icon.classList.toggle('rotate-180', !isExpanded);
    if (!this.isDesktopLayout) {
      icon.parentElement.classList.toggle('bg-lemon', isExpanded);
      icon.parentElement.classList.toggle(
        'text-darkgreen',
        isExpanded
      );
    }

    const content = target.querySelector(
      '[data-nav-dropdown-target=content]'
    );
    content.classList.toggle('hidden');
    content.classList.toggle('md:opacity-0', !isExpanded);
    content.classList.toggle('md:pointer-events-none', !isExpanded);
  }

  toggleOverlayBg(isExpanded) {
    this.bgTarget.classList.toggle('opacity-50', isExpanded);
    this.bgTarget.classList.toggle('opacity-0', !isExpanded);
    this.bgTarget.classList.toggle('hidden', !isExpanded);
  }

  closeAll(excludeTarget = null) {
    this.itemTargets.forEach((item) => {
      if (item !== excludeTarget) {
        const trigger = item.querySelector(
          '[data-nav-dropdown-target=trigger]'
        );
        trigger.setAttribute('aria-expanded', false);
        trigger.classList.remove('md:underline');
        trigger.classList.remove('md:!text-darkgreen');

        const icon = item.querySelector(
          '[data-nav-dropdown-target=icon]'
        );
        icon.classList.add('rotate-180');
        icon.parentElement.classList.remove('bg-lemon');
        icon.parentElement.classList.remove('text-darkgreen');

        const content = item.querySelector(
          '[data-nav-dropdown-target=content]'
        );

        setTimeout(() => {
          content.classList.add(
            'hidden',
            'md:opacity-0',
            'md:pointer-events-none'
          );
        }, 75);
      }
    });
  }

  closeEverything() {
    this.closeAll();
    this.toggleOverlayBg(false);
  }
}
